<template>
  <div class="loading" v-if="loading">
    <loading />
  </div>
  <guage-chart v-else width="300px" :series-data="series" />
</template>
<script>
/* eslint-disable no-eval */
import GuageChart from '@/components/GuageChart'
import Loading from '@/components/Loading.vue'
import { QueryCustomerPercent } from '../services'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'CustomerGaugeChart',
  props: {
    timeSpan: {
      type: Array,
      default () {
        return null
      }
    }
  },
  components: { GuageChart, Loading },
  data () {
    return {
      loading: true,
      series: []
    }
  },
  computed: {
    startDay () {
      if (this.timeSpan) {
        return moment(this.timeSpan[0]).format('YYYY-MM-DD')
      }
      return undefined
    },
    endDay () {
      if (this.timeSpan) {
        return moment(this.timeSpan[1]).format('YYYY-MM-DD')
      }
      return undefined
    }
  },
  watch: {
    startDay () {
      this.loadDataDebounce()
    },
    endDay () {
      this.loadDataDebounce()
    },
    newAdd () {
      this.loadDataDebounce()
    },
    area () {
      this.loadDataDebounce()
    }
  },
  created () {
    this.loadDataDebounce = _.debounce(() => {
      this.loadData()
    }, 30)
  },
  mounted () {
    this.loadDataDebounce()
  },
  methods: {
    loadData () {
      this.loading = true
      QueryCustomerPercent({ newAdd: this.newAdd, area: this.area || undefined, startDay: this.startDay, endDay: this.endDay }).then(resp => {
        let partPercent = 0
        let servicePercent = 0
        if (resp.totalCount) {
          partPercent = eval(Math.round(resp.partCount * 10000.0 / resp.totalCount) + 'e-2')
          servicePercent = eval(Math.round(resp.serviceCount * 10000.0 / resp.totalCount) + 'e-2')
        }
        this.series = [
          {
            value: partPercent,
            name: '配件购买',
            title: {
              offsetCenter: ['0%', '-30px']
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '-10px'],
              formatter: `${partPercent}%(${resp.partCount}/${resp.totalCount})`
            }
          },
          {
            value: servicePercent,
            name: '服务购买',
            title: {
              offsetCenter: ['0%', '10px']
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '30px'],
              formatter: `${servicePercent}%(${resp.serviceCount}/${resp.totalCount})`
            }
          }
        ]
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
